// ===============================================
// THIS IS A GENERATED FILE - Do NOT edit manually
//
// @see libs/data-access/generator/README.md
//
// ===============================================
import { useQuery } from '@tanstack/react-query';

import { createUrlFromPattern } from '@cntxt/domains/access-control';
import { axiosFetch } from '@cntxt/shared/infrastructure/api/http';
import { APIReturnType } from '@cntxt/shared/infrastructure/api/routing';

import { API_BASE } from '../../../shared/constants';
import { getAccess as APIHandler, EndpointParams } from '../api/getAccess';

import { iamKeys } from './keys';

const network = (
  queryParams: { status: string },
  { signal }: { signal?: AbortSignal } = {},
): APIReturnType<typeof APIHandler, EndpointParams> => {
  const apiUrl = createUrlFromPattern(`${API_BASE}iam/access`, {});
  return axiosFetch({
    apiUrl,
    method: 'GET',
    params: queryParams,
    signal,
  });
};

export const useGetAccessQuery = (
  { status }: { status: string } = { status: '' },
) => {
  return useQuery({
    queryKey: iamKeys.all(),
    queryFn: () => {
      return network({ status });
    },
    enabled: status ? status === 'authenticated' : true,
  });
};
